<button
  mat-raised-button
  color="primary"
  class="upload-btn"
  type="button"
  (click)="fileInput.click()"
  [disabled]="control().value"
>
  <mat-icon>cloud_upload</mat-icon>
  <span>{{ 'USER.REIMBURSEMENT_REQUESTS.UPLOAD_FILE' | translate }}</span>
</button>
@if (control().value) {
  <div class="file-names">
    <span>{{ control().value.name }}</span>
    <mat-icon (click)="deleteFile()">cancel</mat-icon>
  </div>
}
@if (!control().value) {
  <mat-error class="file-names error">{{
    'FILE_UPLOAD_BUTTON.ERROR_REQUIRED' | translate
  }}</mat-error>
}
<input type="file" #fileInput hidden (change)="onFileSelected($event)" [accept]="acceptAttr" />
